<template>
  <div class="p-option-bar-container row">
    <div class="p-option-bar-button-group">
      <button
        type="button"
        v-for="(option, idx) in options"
        :key="idx"
        :class="{ active: option.pressed }"
        class="p-option-bar-button-group-item capitalize-first"
        v-on:click="toggleOnOff(option)"
      >
        {{ option.text }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";

@Component
export default class POptionBar extends Vue {
  @Prop({
    required: true,
    default: [],
  })
  options!: { text: string; pressed: boolean; data: any }[];

  @Prop({
    required: false,
    default: true,
  })
  onlyOneActive!: boolean;

  @Prop({
    required: false,
    default: false,
  })
  navigation!: boolean;

  mounted(): void {
    if (this.navigation) {
      this.$router.afterEach((to) => {
        const option = this.options.find((o) => to.path.toString().includes(o.data));

        if (option) {
          this.pressOption(option);
        }
      });
    }
  }

  toggleOnOff(option: { text: string; pressed: boolean; data: any }): void {
    this.pressOption(option);
    this.$emit("onPressed", option.data);
  }

  pressOption(option: { text: string; pressed: boolean; data: any }): void {
    if (this.onlyOneActive) {
      this.options.forEach((o) => (o.pressed = false));
    }
    option.pressed = !option.pressed;
  }
}
</script>

<style lang="scss" scoped>
.p-option-bar-button-group-item {
  min-width: 5rem;
  height: 2.4rem;
  border: solid 1px #e8e8e8;
  background-color: var(--blanco-prosegur);
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  color: var(--secundario-prosegur-oscuro);
  padding-left: 2rem;
  padding-right: 2rem;

  &:first-of-type {
    border-top-left-radius: 2rem;
    border-bottom-left-radius: 2rem;
    padding-left: 2.5rem;
  }

  &:last-of-type {
    border-top-right-radius: 2rem;
    border-bottom-right-radius: 2rem;
    padding-right: 2.5rem;
  }

  &:hover {
    border: solid 1px var(--amarillo-prosegur);
  }

  &.active {
    border: solid 1px var(--amarillo-prosegur) !important;
    background-color: var(--amarillo-prosegur) !important;
    font-weight: bold;
  }
}

.p-option-bar-container {
  justify-content: center;
  padding: 1rem;
}

.capitalize-first::first-letter {
  text-transform: uppercase;
}
</style>
